import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { reportRoute } from 'embedded';

/** Во встроенном режиме сообщает новому интерфейсу каждый переход, чтобы адрес и заголовок вкладки шли следом. */
const EmbeddedRouteReporter: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    reportRoute(`${pathname}${search}`, document.title);
  }, [pathname, search]);

  return null;
};

export default EmbeddedRouteReporter;
